export const kindLabels = {
  P: 'APP.IAB.PURCHASABLE',
  F: 'APP.IAB.5_MINUTES_SUBSCRIBE',
  D: 'APP.IAB.1_DAY_SUBSCRIBE',
  W: 'APP.IAB.7_DAY_SUBSCRIBE',
  M: 'APP.IAB.30_DAYS_SUBSCRIBE',
  T: 'APP.IAB.60_DAYS_SUBSCRIBE',
  E: 'APP.IAB.90_DAYS_SUBSCRIBE',
  S: 'APP.IAB.180_DAYS_SUBSCRIBE',
  A: 'APP.IAB.365_DAYS_SUBSCRIBE',
};

export default function getKindLabels(kind) {
  const label = kindLabels[kind];
  if (!label) return '';
  return label;
}
